import { useState } from "react";
import { parseWhole } from "../../lib/shield";

// Rejects invalid input (keeps previous value) and explains why.
export const NumberField = ({ id, label, value, onCommit, testId, max = 100, emptyHint = "Empty – shows a dash on the shield" }) => {
  const [error, setError] = useState("");
  const change = (raw) => {
    const r = parseWhole(raw, max);
    if (r.ok) { setError(""); onCommit(r.value); } else setError(r.error);
  };
  return (
    <div>
      <label htmlFor={id} className="flex items-baseline justify-between gap-2 text-sm font-bold">
        <span>{label}</span>
        <span className="text-[11px] font-semibold uppercase tracking-wider text-slate-400">0–{max}</span>
      </label>
      <input id={id} type="text" inputMode="numeric" autoComplete="off" value={value} placeholder="Enter value"
        onChange={(e) => change(e.target.value)} onBlur={() => setError("")} data-testid={testId} aria-invalid={!!error}
        className={`font-cond mt-1 w-full border-2 bg-white px-3 py-2 text-2xl font-bold outline-none transition-colors placeholder:text-base placeholder:font-medium placeholder:text-slate-400 ${error ? "border-red-500" : "border-slate-200 focus:border-slate-900"}`} />
      <div className="mt-1 min-h-[1rem] text-xs" aria-live="polite">
        {error ? <span className="text-red-600" data-testid={`${testId}-error`}>{error}</span>
          : value === "" ? <span className="text-slate-400">{emptyHint}</span> : null}
      </div>
    </div>
  );
};
